export enum AuthMethodEnum {
  RO_AUTHORIZED = 0,
  FOWARD_TO_WO = 1,
  SPLIT_AUTHORIZATION = 2,
  WO_AUTHORIZED = 3,
  NOT_AUTHORIZED = 4,
}
